<style scoped>
.server-alert {
  text-align: center;
  position: absolute;
  width: 100%;
  margin: auto;
  background-color: #fd0d03;
  color: yellow;
  font-size: 16px;
  font-weight: 600;
}
</style>

<template>
  <div id="app">
    <MobileMenu v-if="this.HeaderFooter" />
    <HeaderDefault
      :count="contador"
      :cartRedirect="linkCarrinho"
      :productList="productList"
      :totalKombi="totalKombi"
      :kombiList="kombiList"
      v-if="this.HeaderFooter && this.showHeader"
    />
    <div v-if="!!this.mensagemVersaoDoNode" style="padding-bottom: 20px">
      <div class="row server-alert">
        {{ this.mensagemVersaoDoNode }}
      </div>
    </div>
    <div v-if="this.homologacao">
      <div class="row server-alert">VERSÃO DE HOMOLOGAÇÃO</div>
    </div>
    <div class="row" v-show="isHomePage">
      <div class="col-md-12 TitleCarousel">
        <h1>Bem-vindo ao maior distribuidor de energia solar do Brasil</h1>
      </div>
      <HomePageCarousel style="padding-bottom: 20px !important"></HomePageCarousel>
    </div>

    <router-view></router-view>
    <FooterDefault v-if="this.Footer" />
  </div>
</template>

<script>
import MobileMenu from './components/partials/MobileMenu.vue'
import HeaderDefault from './components/partials/HeaderDefault.vue'
import FooterDefault from './components/partials/FooterDefault.vue'
import axios from 'axios'
import HomePageCarousel from './components/partials/HomePageCarousel'
import MonitoringError from './services/MonitoringError'

export default {
  name: 'app',
  components: {
    MobileMenu,
    HeaderDefault,
    FooterDefault,
    HomePageCarousel,
  },
  data() {
    return {
      HeaderFooter: true,
      Footer: true,
      contador: '',
      showHeader: false,
      productList: [],
      isQuotation: false,
      totalKombi: 0,
      linkCarrinho: '#',
      kombiList: [],
      codigoKombi: 0,
      session: JSON.parse(localStorage.getItem('usuarioLogado')),
      mensagemVersaoDoNode: null,
      homologacao: false,
      isHomePage: false,
    }
  },
  methods: {
    async getSession() {
      const self = this
      self.showHeader = true
      const result = await $.ajax({
        url: this.$apiUrl + '/Session.svc/getsessions',
        dataType: 'json',
        type: 'GET',
        xhrFields: { withCredentials: true },
        success: (data) => {
          if (location.href.includes('/login')) {
            location.href = '/loja'
            return
          }
          var session = data
          localStorage.setItem('usuarioLogado', JSON.stringify(data))
          if (session.CodigoPedido === -1 && session.CodigoOrcamento === -1) {
            self.contador = '0 ITENS'
            self.linkCarrinho = '#'
          } else if (session.CodigoPedido != -1) {
            self.codigoKombi = session.CodigoPedido
            self.isQuotation = false
            self.getTipoPedido(session.CodigoPedido)
            this.getPedidosNormalCliente()
          } else if (session.CodigoOrcamento != -1) {
            self.codigoKombi = session.CodigoOrcamento
            self.isQuotation = true
            self.getTipoPedido(session.CodigoOrcamento)
            this.getPedidosOrcamentoCliente()
          }
          self.updateProducts()
          self.$forceUpdate()
          return true
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          self.contador = '0 ITENS'
          self.showHeader = true
          self.productList = []
          self.totalKombi = 0

          const user = JSON.parse(localStorage.getItem('usuarioLogado'))

          if (user && user.DadosCliente) {
            const err = {
              codigoUsuario: user.DadosCliente.CliCodigo,
              status: 401,
              msg: 'Usuário não autenticado',
            }

            const vm = {
              $route: {
                fullPath: self.$vnode.context.$options.router.history.current.fullPath,
              },
              $vnode: {
                tag: self.$vnode.tag,
              },
            }

            MonitoringError.SendError(self.$apiUrl, err, vm, { info: 'getSession' })
          }

          localStorage.removeItem('usuarioLogado')
          localStorage.removeItem('waitingLogin')
          error: () => {
            swal({
              title: 'É necessário estar logado',
              icon: 'warning',
            }).then(() => (location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href))
          }
          return false
        },
      })
      return result
    },
    getList() {
      const self = this
      self.showHeader = true
      setTimeout(function () {
        let session = JSON.parse(localStorage.getItem('usuarioLogado'))
        if (session && session.DadosCliente != null) {
          if (session.CodigoPedido === -1 && session.CodigoOrcamento === -1) {
            self.contador = '0 ITENS'
            self.linkCarrinho = '#'
          } else if (session.CodigoPedido != -1) {
            self.codigoKombi = session.CodigoPedido
            self.isQuotation = false
            self.getTipoPedido(session.CodigoPedido)
          } else if (session.CodigoOrcamento != -1) {
            self.codigoKombi = session.CodigoOrcamento
            self.isQuotation = true
            self.getTipoPedido(session.CodigoOrcamento)
          }
          self.updateProducts()
        } else {
          self.contador = '0 ITENS'
          self.showHeader = true
          self.productList = []
          self.totalKombi = 0
        }
      }, 500)
    },
    updateProducts() {
      const self = this
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            self.productList = []
            json.forEach((element) => {
              let item = {}
              item.qtd = element.QtdePedido.replace(',00', '')
              item.imgSrc = element.UrlImagem
              item.descr = element.Descricao
              item.price = element.ValorUnitario.replace(',', '.')
              item.code = element.Codigo
              item.codeDv = element.CodigoDv
              item.valorUnit = element.ValorUnitario
              if (element.ProdutoPai == '|0|') {
                self.productList.push(item)
              }
            })
            var sufix = self.productList.length == 1 ? ' ITEM' : ' ITENS'
            self.contador = self.productList.length + sufix
            self.totalKombi = 0
            self.productList.forEach(function (element, index) {
              self.totalKombi = self.totalKombi + parseFloat(element.valorUnit.replace(',', '.')) * parseFloat(element.qtd.replace(',', '.'))
            })
          }
        }
      }
      xhr.open('POST', this.$apiUrl + '/Carrinho.svc/ListarItens')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          orcamento: self.isQuotation,
          codigoPedido: self.codigoKombi,
        })
      )
    },
    getTipoPedido: function (codigoPedido) {
      const self = this

      let xhr = new XMLHttpRequest()

      xhr.open('POST', this.$apiUrl + '/Carrinho.svc/GetTipoPedido')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.onload = () => {
        if (xhr.status == 200) {
          let response = JSON.parse(xhr.responseText)
          localStorage.setItem('GetTipoPedido', response)
          if (response.includes('DIRETA')) {
            if (self.isQuotation) self.linkCarrinho = '/loja/meu-carrinho-venda-direta/cotacao'
            else self.linkCarrinho = '/loja/meu-carrinho-venda-direta/carrinho'
          } else if (response.includes('IMOBILIZADO')) self.linkCarrinho = '/loja/meu-carrinho-venda-direta/carrinho'
          else {
            if (self.isQuotation) self.linkCarrinho = '/loja/meu-carrinho/cotacao'
            else self.linkCarrinho = '/loja/meu-carrinho/carrinho'
          }
        }
      }

      xhr.send(
        JSON.stringify({
          codigoPedido: codigoPedido,
        })
      )
    },
    getPedidosNormalCliente() {
      axios
        .post(
          this.$apiUrl + '/Cliente.svc/pedidoscliente',
          {
            orcamento: false,
          },
          { withCredentials: true }
        )
        .then((response) => {
          let pedidos = response.data
          pedidos.forEach((element) => {
            let kombi = {}
            kombi.code = element.Codigo_pedido
            kombi.value = element.Total_nota_fiscal
            kombi.dataFaturamento = element.DataFaturamentoFormatada
            kombi.selected = this.codigoKombi == kombi.code ? true : false
            kombi.vendaDireta = kombi.VendaDireta
            this.kombiList.push(kombi)
          })
        })
    },
    getPedidosOrcamentoCliente() {
      axios
        .post(
          this.$apiUrl + '/Cliente.svc/pedidoscliente',
          {
            orcamento: true,
          },
          { withCredentials: true }
        )
        .then((response) => {
          let pedidos = response.data
          pedidos.forEach((element) => {
            let kombi = {}
            kombi.code = element.Codigo_pedido
            kombi.value = element.Total_nota_fiscal
            kombi.dataFaturamento = element.DataFaturamentoFormatada
            kombi.selected = this.codigoKombi == kombi.code ? true : false
            kombi.vendaDireta = kombi.VendaDireta
            this.kombiList.push(kombi)
          })
        })
    },
    verificarVersaoDoNode() {
      axios.get(`${this.$apiUrl}/FuncoesGerais.svc/obterVersaoDoNode`).then((response) => {
        if (response.data) {
          var versaoHomologada = 'v16.16.0'
          var versaoDoServidor = response.data

          if (versaoDoServidor !== versaoHomologada) {
            this.mensagemVersaoDoNode = `A versão node do servidor (${versaoDoServidor}) é diferente da versão homologada (${versaoHomologada}).`
            console.warn(this.mensagemVersaoDoNode)
          }
        }
      })
    },
    verificarAmbiente() {
      axios.get(`${this.$apiUrl}/FuncoesGerais.svc/obterAmbiente`).then((response) => {
        this.homologacao = response.data === 'homologacao'
      })
    },
  },
  async mounted() {    
    await this.getSession()
  },
  beforeMount() {
    const routesWithoutHeaderFooter = ['PáginaInicial', 'BoletoView', 'BoletoAVistaView', 'pagamento-do-pedido', 'template-proposta', 'csat-venda']
    const routesWithoutFooter = ['BoletoView', 'BoletoAVistaView', 'template-proposta', 'csat-venda']

    if (routesWithoutHeaderFooter.includes(this.$route.name)) {
      this.HeaderFooter = false
    }

    if (routesWithoutFooter.includes(this.$route.name)) {
      this.Footer = false
    }

    this.verificarVersaoDoNode()
    this.verificarAmbiente()
    this.isHomePage = ['/loja', '/loja/'].includes(document.location.pathname)
  },
}
</script>
